module.exports = "/images/vendor/svg-country-flags/svg/it.svg?58e75cebaf765e503d29181def4c9fee";